import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const Header = () => {
  return (
    <div className="EditorElement-header p-32">
      <div className="d-f ai-c jc-sb">
        <Text className="mb-4 d-f ai-c" variant={TEXT_VARIANTS.SUBHEADER}>
          {t('questions.types.elearning.title')}
        </Text>
      </div>
      <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
        {t('questions.types.elearning.hint')}{' '}
      </Text>
      <Text
        component="a"
        variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD_LINK}
        target="_blank"
        rel="noopener noreferrer"
        href="https://intercom.help/lessonly/en/articles/6878866"
      >
        {t('questions.types.elearning.learn_more')}
      </Text>
    </div>
  );
};

export default Header;
